/* eslint-disable import/no-extraneous-dependencies */

import moment from 'moment';
import VerificationTripModel from 'models/verification';


type verificationDealResponseModel = {
  tripId: number,
  clientId: string,
  imgs: Array<string>,
  comment: string,
  isReviewed: boolean,
  verificationStatus: number,
  id: string,
  createdOn: string,
  createdOnTS: number,
  fio: string,
};

const createTripfromRowData = (responseItem: verificationDealResponseModel): any => {
  return new VerificationTripModel({
    createdOn: moment(responseItem.createdOnTS).format('DD.MM.YYYY HH:mm').toString(),
    clientId: responseItem?.clientId,
    verificationStatus: responseItem?.verificationStatus,
    id: responseItem.id,
    tripId: responseItem.tripId,
    isReviewed: responseItem.isReviewed,
    fio: responseItem.fio,
  });
};

export const createVerificationTripFromRowData = (
  response: Array<verificationDealResponseModel>
): Array<VerificationTripModel> =>
  response.map((item: verificationDealResponseModel) => createTripfromRowData(item));

export default createVerificationTripFromRowData;
